export default {
  computed: {
    isQuizModeEnabled() {
      return this.schema?.settings?.is_quiz;
    },
  },
};
